module.exports = __webpack_public_path__ + "static/4x_hr_onboarding_5-c3016d800ec5fd7f5351220c418c1dd0.png";